/*
 * This module is currently not being used. Initially the design included it for customer selection
 * during manual case creation. However, the customer listing API is not available, and would require
 * significant work to develop. We keep this module here to be used when that API is ready.
 */
import { call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  fetchCustomersFail,
  fetchCustomersSuccess,
  FETCH_CUSTOMERS
} from '../../redux/actions/cm/customers';
import { fetchCustomers as fetchCustomersService } from '../../services/cm/customers';

function* fetchCustomerListWorker({ currentPage, pageSize }) {
  try {
    const { customers, total } = yield call(fetchCustomersService, {
      currentPage,
      pageSize
    });
    yield put(fetchCustomersSuccess({ customers, total }));
  } catch (error) {
    yield put(fetchCustomersFail());
  }
}

export function* watchFetchCustomerList() {
  yield takeEvery(
    FETCH_CUSTOMERS,
    function* ({ payload: { currentPage, pageSize } }) {
      yield fork(fetchCustomerListWorker, { currentPage, pageSize });
    }
  );
}
